import { render } from "./FiderComponent.vue?vue&type=template&id=e4323b04&lang=true"
import script from "./FiderComponent.vue?vue&type=script&lang=js"
export * from "./FiderComponent.vue?vue&type=script&lang=js"

import "./FiderComponent.vue?vue&type=style&index=0&id=e4323b04&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__